import Vue from "vue";

Vue.component("note-item-management", {
    props: ["note", "party", "contextId"],
    data() {
        return {
            noteItemId: 0,
            loading: false,
            partyCode: this.party,
            counter: 0,
            currentId: this.contextId,
            controlContextId: '0|0|0'
        };
    },
    methods: {
        selectItem(model) {
            const self = this;

            if (model != null) {
                self.selected = model;
                self.$refs.fieldEditor.initialize(model.id);
            }
        }
    },
    watch: {
        controlContextId: function (context) {
            const self = this;

            if (context != null && context != undefined && context != '0|0|0') {
                const splitted = context.split('|');
                if (splitted != null && splitted[0] != null && splitted[1] != null) {
                    if (splitted[1] == '0') {
                        self.$refs.fieldEditor.initialize(splitted[0]);
                    }
                    else {
                        self.counter += 1;
                        self.currentId = self.id + '|1|' + self.counter;

                        self.$emit('update:contextId', self.currentId);
                    }
                }
            }
        }
    },
    computed: {
        descriptionLabel: function () {
            return window.labels.description;
        },
        groupLabel: function () {
            return window.labels.group;
        },
        classLabel: function () {
            return window.labels.class;
        },
        subclassLabel: function () {
            return window.labels.subclass;
        },
        coverageExclusionTooltipLabel: function () {
            return window.labels.coverageExclusionTooltip;
        }
    },
    template: `
		<div>
			<table :class="{ 'has-four-item-columns': note.hasFourItemColumns }" class="table is-narrow is-striped is-hoverable">				
				<thead>
					<tr>
						<th style="width: 5%">&nbsp;</th>
						<th style="width: 85%">{{ descriptionLabel }}</th>
						<th v-if="note.hasFourItemColumns">{{ groupLabel }}</th>
						<th v-if="note.hasFourItemColumns">{{ classLabel }}</th>
						<th v-if="note.hasFourItemColumns">{{ subclassLabel }}</th>
						<th style="width: 10%">{{ note.classificationSystem }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in note.items" :key="item.id" :id="'noteItem_' + item.id" style="cursor: pointer" @click="selectItem(item)">
						<td>{{ item.referenceNumber }}</td>
						<td>						
							<i v-if="item.excluded" class="fas fa-ban has-text-danger" :title="coverageExclusionTooltipLabel"></i>
							<span v-html="item.description"></span>
						</td>
						<td v-if="note.hasFourItemColumns">{{ item.groupText }}</td>
						<td v-if="note.hasFourItemColumns">{{ item.classText }}</td>
						<td v-if="note.hasFourItemColumns">{{ item.subclassText }}</td>
						<td><span v-html="item.detailsText"></span></td>
					</tr>
				</tbody>
			</table>			
			<note-item-basic-info-editor ref="fieldEditor" :useModal="true" :party="partyCode" :contextId.sync="controlContextId"></note-item-basic-info-editor>
		</div>
	`
});